import { useParams } from "react-router";
import { useSummaryItemReport } from "@/services/backend/htz/summary/hooks/use-summary-item-report";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { DocumentBlobCard } from "@/services/backend/filestorage/components/document-blob-card";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

/**
 * ReportFilesRoute lists the files attached to an Anlagenbericht, e.g. the
 * results of a laboratory.
 */
export function ReportFilesRoute() {
  const { summaryId, itemId } = useParams();
  const { reportId } = useSummaryItemReport(summaryId!, itemId!);
  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! }, { skip: !reportId });

  if (isLoading) {
    return null;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <DocumentBlobCard
      subdomain={GSMServiceKind.HTZ}
      documentKind={GSMDocumentKind.Report}
      documentId={report!.id}
      accept="application/pdf,image/jpeg,image/png"
      disabled={isImmutable(report!)}
    />
  );
}
